// extracted by mini-css-extract-plugin
module.exports = {"overlay":"LoadingOverlay_overlay__N_VRe","text":"LoadingOverlay_text__0nAWf"};